'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUnpublishedMessage = undefined;

var _PubNubMessageStatusTypes = require('../../constants/PubNubMessageStatusTypes');

var _buildMessageWithStatus = require('./buildMessageWithStatus');

var buildUnpublishedMessage = exports.buildUnpublishedMessage = (0, _buildMessageWithStatus.buildMessageWithStatus)(_PubNubMessageStatusTypes.UNPUBLISHED);